import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../Styles/auth/auth.scss";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import isoEventLogo from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import LoginStep from "../../utilities/functions/loginProcessStep";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";

const TwoFA = () => {
  const dispatch = useDispatch();
  const { token, roles } = useSelector((state) => state.user);
  const mobile = localStorage.getItem("mobile");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const headers = {
    Authorization: "Bearer " + localStorage.getItem("tokenfa"),
  };
  const [twoFAcode, setTwoFAcode] = useState("");
  const [resendTimer, setResendTimer] = useState(60); // Initial timer value in seconds


  const registerRequestParams = {
    verification_code: twoFAcode
  }

  const twofaAPI = (e) => {

    e.preventDefault(); // Prevent form submission
    setLoading(true);

    axios
      .post(serverConfig.server.url + apiConfig.api.authControllers.twofa, registerRequestParams, { headers })
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          localStorage.setItem('res', JSON.stringify(registerRequestParams))
          if (response.data.data.registered) {
            localStorage.removeItem("tokenfa");
            localStorage.setItem("token", response.data.data.token);
            dispatch(
              setUser({
                first_name: response.data.data.first_name,
                last_name: response.data.data.last_name,
                token: response.data.data.token,
                roles: response.data.data.user_roles,
              })
            );
            localStorage.getItem("callBackURL") &&
              (localStorage.getItem("callBackURL") != "/login" ||
                localStorage.getItem("callBackURL") != "/twofa" ||
                localStorage.getItem("callBackURL") != "/register")
              ? window.location.replace(localStorage.getItem("callBackURL"))
              : window.location.replace("/");
          } else {
            localStorage.removeItem("tokenfa");
            localStorage.setItem("tokenreg", response.data.data.token);
            navigate("/register");
          }
        } else if (response.data.code === 401) {
          toast.error("کد تایید منقضی شده است");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const backToLogin = () => {
    localStorage.removeItem("tokenfa");
    localStorage.removeItem("mobile");
    localStorage.setItem(
      "callBackURL",
      window.location.pathname + window.location.search
    );
    navigate("/login");
  };

  const loginAPI = () => {

    const apiParams = {
      mobile
    }

    const referrer_id = localStorage.getItem('referrer_id')

    if (referrer_id) {
      apiParams.referrer_id = referrer_id
    }

    setLoading(true);
    axios
      .post(serverConfig.server.url + apiConfig.api.authControllers.login, apiParams)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          localStorage.setItem("tokenfa", response.data.data.token);
          localStorage.setItem("mobile", mobile);
          response.data.data.verification_code &&
            toast.success(response.data.data.verification_code);
          // Reset the timer when resend is clicked
          setResendTimer(60);
        } else {
          if (typeof response.data.errors === 'string') {

            // remove the invalid referre_id and re-call the login route again
            if (response?.data?.errors === 'چنین سایتی وجود ندارد!') {
              localStorage.removeItem('referrer_id')
              loginAPI()
              return
            }

            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  // Countdown timer function
  useEffect(() => {
    const timer = setInterval(() => {
      setResendTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    // Clear interval when component unmounts
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let step = LoginStep();
    if (step !== "OK" && step) {
      navigate(step);
    }
  }, []);

  return (
    <div className="container-fluid d-flex pt-5 mt-5 justify-content-center">
      <div className="card-group auth-card">
        <div className="card">
          <img
            src={isoEventLogo}
            className="logo-img d-flex mx-auto my-5"
            alt="..."
          />
          <div className="card-body">
            <h5 className="card-title fs-16 fw-medium">
              کد تایید را وارد کنید
            </h5>
            <p className="fs-12">کد 4 رقمی به شماره {mobile} ارسال شد.</p>
            <form onSubmit={twofaAPI} className="d-flex flex-column">
              <input
                type="number"
                className="form-control mb-2"
                placeholder="1234"
                value={twoFAcode}
                onChange={(e) => {
                  setTwoFAcode(e.target.value);
                }}
                autoFocus
              />
              <button
                type="button"
                className="btn btn-link text-decoration-none"
                onClick={() => {
                  loginAPI();
                }}
                disabled={resendTimer > 0}
              >
                {resendTimer > 0
                  ? `ارسال مجدد (تا ${resendTimer} ثانیه)`
                  : "ارسال مجدد"}
              </button>
              <div className="d-flex flex-row mt-3">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none col-6"
                  onClick={() => {
                    backToLogin();
                  }}
                >
                  تغییر موبایل
                </button>
                <button
                  className="btn btn-primary col-6"
                  type="submit"
                  disabled={loading || !twoFAcode}
                  onClick={twofaAPI}
                >
                  ورود
                  {loading && (
                    <span
                      className="spinner-border spinner-border-sm ms-1"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwoFA;
